<div *ngIf="{currentBlacklist: currentBlacklist$ | async,
             customerList: customerList$ | async,
             jobseekerIgnoredCustomerList: jobseekerIgnoredCustomerList$ | async
             } as data" class="container">
    <div class="blacklist">
        <div class="customers">
            <div class="customers-search">
                <input id="lbl-search" class="customers-search__value" (input)="onCustomerSearchChange($event.target.value)" type="text"/>
                <label for="lbl-search" class="customers-search__label">
                    <svg-icon src="/assets/icons/search.svg" [svgClass]="'customers-search__icon'"></svg-icon>
                </label>
            </div>
            <div class="customers-list">
                <div class="customers-list__container">
                    <div *ngFor="let customer of data.customerList" (click)='onSelectCustomer(customer)' class="customers-list__item">
                        {{ customer.name }}
                    </div>
                </div>
            </div>
            <div *responsive="{sizes:{min: customerListMinSize}}" class="customers-list" [style.height.px]="customerListHeight">
                <div class="customers-list__container">
                    <div *ngFor="let customer of data.customerList" (click)='onSelectCustomer(customer)' class="customers-list__item">
                        {{ customer.name }}
                    </div>
                </div>
            </div>
        </div>
    
        <div class="content content--right">
            <div class="selected-customers" #selectedCustomers>
                <div *ngFor="let customer of data.jobseekerIgnoredCustomerList">
                    <div (click)="removeSelectedCustomer(customer)" class="selected-customers__item">
                        {{ customer.name }}
                        <svg-icon src="/assets/icons/remove.svg" class="remove-icon"></svg-icon>     
                    </div>        
                </div>
            </div>
    
            <div class="text" #text>
                {{ 'text.BlacklistDescription' | translate }}
            </div>
        </div>
    </div>
    
    <div class="buttons">
        <app-button (click)="onSave(data.currentBlacklist)" [text]="'label.Save' | translate" [type]="buttonType.coloured" [typeAttribute]="buttonAttributeType.submit" class="buttons__save"></app-button>
        <app-button (click)="onCancel()" [text]="'label.Cancel' | translate" [type]="buttonType.uncoloured" [typeAttribute]="buttonAttributeType.button"></app-button>
    </div>
</div>
